/**
 * LegalPages — three placeholder legal pages for the PooPartner intake
 * legal-agreement checkbox links.
 *
 * All three render the SAME locked placeholder copy. When counsel
 * finalizes the real documents, they replace this file's copy AND the
 * backend `POOPARTNER_INTAKE_LEGAL_VERSION_ID` bumps from
 * "placeholder-v0" to "v1" (paired update — see the backend Phase 1a
 * drift-guard test).
 */
import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import PublicPageShell from "@/components/PublicPageShell";

const LEGAL_PLACEHOLDER_COPY =
  "Final versions coming at launch — these documents are being prepared with counsel.";

function LegalPlaceholderPage({ title, testid }) {
  return (
    <PublicPageShell mainClass="flex items-center justify-center px-6 py-20">
      <section
        className="max-w-2xl text-center"
        data-testid={testid}
      >
        <h1 className="text-3xl md:text-4xl font-semibold text-pp-text mb-4">
          {title}
        </h1>
        {/* Phase L.2 P3 — audit LP-1. sr-only intermediate H2 so the
            H1 → H3 (SharedFooter columns) heading order doesn't skip
            a level for screen-reader users navigating by heading. */}
        <h2 className="sr-only" data-testid={`${testid}-h2`}>
          Document status
        </h2>
        <p
          className="text-base text-pp-text-muted mb-6"
          data-testid={`${testid}-copy`}
        >
          {LEGAL_PLACEHOLDER_COPY}
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-1 text-sm underline text-pp-orange"
          data-testid={`${testid}-home-link`}
        >
          <ArrowLeft size={14} aria-hidden="true" /> Back to PooPluckers
        </Link>
      </section>
    </PublicPageShell>
  );
}

export function LegalTermsPage() {
  return (
    <LegalPlaceholderPage
      title="Terms of Service"
      testid="legal-terms-page"
    />
  );
}

export function LegalPartnerAgreementPage() {
  return (
    <LegalPlaceholderPage
      title="PooPartner Agreement"
      testid="legal-partner-agreement-page"
    />
  );
}

export function LegalPrivacyPage() {
  return (
    <LegalPlaceholderPage
      title="Privacy Policy"
      testid="legal-privacy-page"
    />
  );
}

export { LEGAL_PLACEHOLDER_COPY };
